module.exports = __webpack_public_path__ + "static/008.thumb-9e890f2055cfa1df70f5fd60e198c9ba.jpg";